import React from 'react';
import { Picture } from 'react-responsive-picture';

import {
  Container,
  ImageContainer,
  BorderContainer,
} from './styles';

import { ICorpContactCardProps } from './types';
import { getPictureSources } from '../../lib/utils/helpers';
import { Text, Title } from './../Typography';

export const CorpContactCard = ({
  id = 'contact-card',
  name,
  description,
  linkedInUrl,
  email,
  phone,
  phoneLink,
  image,
}: ICorpContactCardProps) => {
  return (
    <Container>
      <BorderContainer>
        {image?.asset && image?.asset.length > 0 && <ImageContainer>
          <Picture sources={getPictureSources(image?.asset[0])} alt="" />
        </ImageContainer>}
        <div className="text-center py-9 px-5 flex flex-col justify-between h-full">
          <div>
            <Title type="xs" tag="p" className="mb-6">{name}</Title>
            <Text type="lg" tag="p" className="mb-14">{description}</Text>
          </div>
          <div>
            {linkedInUrl && linkedInUrl.length > 0 && <a href={linkedInUrl} target="_blank" rel="noreferrer"><Text type="list" tag="p" className="mb-4 cursor-pointer">LinkedIn</Text></a>}
            {phone && phone.length > 0 && <a href={`tel:${phoneLink}`}><Text type="lg" tag="p" className="mb-4">{phone}</Text></a>}
            {email && email.length > 0 && <a href={`mailto:${email}`}><Text type="md" tag="p" className="mb-4 cursor-pointer">{email}</Text></a>}
          </div>
        </div>
      </BorderContainer>
    </Container>
  )
};
